import { Box } from "@mui/material";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { deleteSectionAsync } from "../MyPlanDetails/MyPlanDetails.slice";

interface Prop {
  openDeleteDialog: boolean;
  setOpenDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>;
  sectionId: number;
  cardsCount: number;
}

export default function DeleteSection(props: Prop) {
  const dispatch = useAppDispatch();
  const { openDeleteDialog, setOpenDeleteDialog, sectionId, cardsCount } = props;
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);

  const deleteSection = () => {
    const prop = {
      planId: selectedMyPlanDetail.id,
      sectionId
    };
    dispatch(deleteSectionAsync(prop));
    setOpenDeleteDialog(false);
  };

  const handleCloseDialog = () => {
    setOpenDeleteDialog(false);
  };

  return (
    <>
      {openDeleteDialog && (
        <DialogFormation
          title="Delete Section"
          openDialog={openDeleteDialog}
          handleClose={handleCloseDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={handleCloseDialog} width="25%" />
              <Button label="Proceed" width="25%" onClick={deleteSection} />
            </div>
          }
        >
          <div className="vertical-center display-col">
            {cardsCount > 0
              ? `This will permanently delete ${cardsCount} actions with the Section.`
              : ` This will permanently delete the Section.`}
            <Box>Do you wish to proceed?</Box>
          </div>
        </DialogFormation>
      )}
    </>
  );
}
